module.exports = __webpack_public_path__ + "static/media/Easy-Run-Logo-Header.e71f8417.png";